// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"26d6c4f4","133":"f54ecc83","225":"68b7c305","373":"657d50a0","406":"7c65f4e1","453":"52fd4f5c","639":"1dd70976","728":"42bc88b2","816":"c8826161","878":"278b5292"}[chunkId] + ".chunk.js";
};